import "core-js/modules/es.array.includes.js";
import React from 'react';
import { ExternalLink } from '@finect/tabular-icons/externalLink';
import { AppLinkInner } from './partials';
export var Link = function Link(_ref) {
  var href = _ref.href,
    text = _ref.text,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target;
  return React.createElement(AppLinkInner, {
    href: href,
    target: target
  }, ['_blank'].includes(target) ? React.createElement(ExternalLink, {
    size: "16"
  }) : null, text);
};